/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommStaffCardData } from './ecomm-staff-card.data';
import { IEcommStaffCardProps } from './ecomm-staff-card.props.autogenerated';

export interface IEcommStaffCardViewProps extends IEcommStaffCardProps<IEcommStaffCardData> {
    name: string;
    position: string;
    image: MsDyn365.IImageData;
    TemplateContainerStyle: any;
    InfoContainerStyle: any;
    ImageContainerStyle: any;
    NoImage: any;
}

/**
 *
 * EcommStaffCard component
 * @extends {React.PureComponent<IEcommStaffCardProps<IEcommStaffCardData>>}
 */
class EcommStaffCard extends React.PureComponent<IEcommStaffCardProps<IEcommStaffCardData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const EcommStaffCardViewProps = {
            ...this.props,
            name: config.name,
            position: config.position,
            image: config.image,
            TemplateContainerStyle: {
                className: 'ecomm-staff-card'
            },
            InfoContainerStyle: {
                className: 'info-container'
            },
            ImageContainerStyle: {
                className: 'img-container'
            },
            NoImage: {
                className: 'msc-empty_image'
            }
        };

        return this.props.renderView(EcommStaffCardViewProps);
    }
}

export default EcommStaffCard;
